import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=77e64620&"
import script from "./Bank.vue?vue&type=script&lang=js&"
export * from "./Bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77e64620')) {
      api.createRecord('77e64620', component.options)
    } else {
      api.reload('77e64620', component.options)
    }
    module.hot.accept("./Bank.vue?vue&type=template&id=77e64620&", function () {
      api.rerender('77e64620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/Bank.vue"
export default component.exports